import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const USE_CREDENTIALS = process.env.REACT_APP_API_USE_CREDENTIALS === 'true';

// Replace this with wherever your app stores the token (localStorage, context, cookie).
// If you keep tokens in a React context, export a setter/getter from that module and
// import it here. Keep this function minimal and synchronous.
export function getAuthToken() {
    try {
        return localStorage.getItem('token');
    } catch (e) {
        return null;
    }
}

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: USE_CREDENTIALS,
});

// Inject token only when present to avoid "Bearer undefined"
api.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Lightweight debug info (doesn't log token itself)
        try {
            console.debug('[axios] req:', {
                method: config.method,
                url: config.baseURL ? config.baseURL + config.url : config.url,
                authHeaderPresent: !!config.headers?.Authorization,
                hasTokenInStorage: !!token,
                withCredentials: config.withCredentials,
            });
        } catch (e) {}

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (resp) => resp,
    (error) => {
        try {
            console.debug('[axios] resp err:', {
                message: error.message,
                status: error.response?.status,
                url: error.config?.url,
            });
        } catch (e) {}

        const status = error.response?.status;
        if (status === 401 || status === 403) {
            // default behavior: clear token and redirect to login
            try { localStorage.removeItem('token'); } catch (e) {}
            if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export { api };
export default api;
